export enum PROJECT_ACTION_TYPES {
    GET_PROJECT_START = 'project/GET_PROJECT_START',
    GET_PROJECT_SUCCESS = 'project/GET_PROJECT_SUCCESS',
    GET_PROJECT_FAILED = 'project/GET_PROJECT_FAILED',
    GET_MY_PROJECTS_START = 'project/GET_MY_PROJECTS_START',
    GET_MY_PROJECTS_SUCCESS = 'project/GET_MY_PROJECTS_SUCCESS',
    GET_MY_PROJECTS_FAILED = 'project/GET_MY_PROJECTS_FAILED',
    CLEAR_PROJECT_SELECTED = 'project/CLEAR_PROJECT_SELECTED',
    CLEAR_NODE_PROJECT_SELECTED = 'project/CLEAR_NODE_PROJECT_SELECTED',
};